import { ValueMap } from './type';

export const titreValueMap: ValueMap[] = [
    {
        value: 'Monsieur',
        color: 'gray',
        icon: 'UserIcon',
    },
    {
        value: 'Madame',
        color: 'gray',
        icon: 'UserIcon',
    },
    { value: 'Frau', color: 'gray', icon: 'UserIcon' },
    { value: 'Herr', color: 'gray', icon: 'UserIcon' },
    { value: 'Madame, Monsieur,', color: 'gray', icon: 'UserIcon' },
    { value: 'Messieurs', color: 'gray', icon: 'UserIcon' },
    { value: 'Mesdames', color: 'gray', icon: 'UserIcon' },
    { value: 'Herren', color: 'gray', icon: 'UserIcon' },
    { value: 'Frauen', color: 'gray', icon: 'UserIcon' },
    { value: 'Dr', color: 'gray', icon: 'UserIcon' },
    { value: 'Drsse', color: 'gray', icon: 'UserIcon' },
    { value: 'Maître', color: 'gray', icon: 'UserIcon' },
];
